(function () {
  var SWIPER_SELECTOR = '.tier-overview__snippet .yotpo-vip-tiers-swiper';
  var POLL_INTERVAL = 250;
  var POLL_ATTEMPTS = 60;

  function slideGap(element) {
    var value = parseFloat(getComputedStyle(element).getPropertyValue('--tier-slide-gap'));
    return isNaN(value) ? 10 : value;
  }

  function tune(element) {
    var swiper = element.swiper;
    if (!swiper || swiper.destroyed || !swiper.params) return false;

    var gap = slideGap(element);
    if (swiper.params.slidesPerView === 'auto' && swiper.params.spaceBetween === gap) return true;

    swiper.params.slidesPerView = 'auto';
    swiper.params.spaceBetween = gap;
    swiper.update();
    return true;
  }

  function scan() {
    var elements = document.querySelectorAll(SWIPER_SELECTOR);
    var pending = false;
    for (var i = 0; i < elements.length; i++) {
      if (!tune(elements[i])) pending = true;
    }
    return elements.length > 0 && !pending;
  }

  function watch() {
    if (!window.MutationObserver) return;
    var sections = document.querySelectorAll('.tier-overview__snippet');
    for (var i = 0; i < sections.length; i++) {
      new MutationObserver(function () {
        scan();
      }).observe(sections[i], { childList: true, subtree: true });
    }
  }

  function init() {
    watch();
    if (scan()) return;
    var attempts = 0;
    var timer = setInterval(function () {
      if (scan() || ++attempts >= POLL_ATTEMPTS) clearInterval(timer);
    }, POLL_INTERVAL);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
